module.exports = __webpack_public_path__ + "img/good-hood-music.2b2ad89d.svg";